import React from "react";
import { DeprecatedDetailText as NessieDeprecatedDetailText, NessieThemeProvider } from "@classdojo/web";

export const DeprecatedDetailText = (props: any) => {
  return (
    <NessieThemeProvider>
      <NessieDeprecatedDetailText {...props} />
    </NessieThemeProvider>
  );
};
